import { create } from 'zustand';
import { AdvanceQuestionType } from './advanceQuestion/hooks';
import { CustomerInfoType } from './customerInfo/hooks';
/*--------------
  口座開設
  --------------*/
//入力データ管理
type EstablishStore = {
  param: PersonalAccountEstablishRequestParam;
  add: (data: PersonalAccountEstablishRequestParam) => void;
  clear: () => void;
};

export const usePersonalAccountEstablishStore = create<EstablishStore>((set) => ({
  param: {} as PersonalAccountEstablishRequestParam,
  add: (data: PersonalAccountEstablishRequestParam) =>
    // 前のデータは残してセットしたい
    set((state) => ({ param: { ...state.param, ...data } })),
  clear: () => set({ param: {} as PersonalAccountEstablishRequestParam }),
}));

export type PersonalAccountEstablishRequestParam = AdvanceQuestionType &
  CustomerInfoType;

type UpdateStore = {
  param: PersonalAccountUpdateRequestParam;
  add: (data: PersonalAccountUpdateRequestParam) => void;
  clear: () => void;
};

export const usePersonalUpdateStore = create<UpdateStore>((set) => ({
  param: {} as PersonalAccountUpdateRequestParam,
  add: (data: PersonalAccountUpdateRequestParam) =>
    // 前のデータは残してセットしたい
    set((state) => ({ param: { ...state.param, ...data } })),
  clear: () => set({ param: {} as PersonalAccountUpdateRequestParam }),
}));

export type PersonalAccountUpdateRequestParam = CustomerInfoType;
